<div class="subpage-container">
  <div class="container g-0 m-0">
    <div class="row d-flex justify-content-between g-0 m-0 mb-3 p-0">
      <div class="col-10 d-flex align-items-center justify-content-start g-0 m-0 ps-5">
        <app-sort class="pe-2" (close)="onSortOption($event)"></app-sort>
        <div class="datepicker-container-wrapper position-relative">
          <div class="button-wrapper pe-2">
            <div class="button">
              <img alt="Date" src="assets/core/table-button/date.svg" />
              <div class="button-text"
                [ngClass]="{ changed: requestData.startDate && requestData.endDate }">
                <ng-container *ngIf="requestData.startDate && requestData.endDate; else noDateSelected">
                  {{ selectedDate }}
                </ng-container>
                <ng-template #noDateSelected>
                  <span class="nonselected-date">{{ "SELECTDATE" | translate }}</span>
                </ng-template>
              </div>
              <img *ngIf="requestData.startDate && requestData.endDate" alt="Exit" src="assets/device/x.svg"
                (click)="clearDates()" />
            </div>
          </div>
          @if (isDatepickerOpen) {
          <div class="overlay" (click)="toggleDatepicker()"></div>
          <app-datepicker [scale]="1.1" [range]="true" (dateRangeChanged)="onDateRangeChanged($event)"
            [inputFromDate]="requestData.startDate" [inputToDate]="requestData.endDate"></app-datepicker>
          }
        </div>
        <app-search placeholder="{{ 'SCHEDULED_DATA_SEARCHBY' | translate }}"
          (searchChange)="searchChange($event)"></app-search>
      </div>
    </div>
    <div class="row g-0 m-0">
      <table>
        <thead>
          <tr>
            <th></th>
            <th>
              <div class="column-content">
                <img alt="Column" src="assets/device/column-menu.svg" />
                <span>{{ "DEVICESETUP_METERNO" | translate }}</span>
              </div>
            </th>
            <th>
              <div class="column-content">
                <img alt="Column" src="assets/device/column-menu.svg" />
                <span>{{ "DEVICESETUP_METERIP" | translate }}</span>
              </div>
            </th>
            <th>
              <div class="column-content">
                <img alt="Column" src="assets/device/column-menu.svg" />
                <span>{{ "DEVICESETUP_METERPORT" | translate }}</span>
              </div>
            </th>
            <th>
              <div class="column-content">
                <img alt="Column" src="assets/device/column-menu.svg" />
                <span>{{ "DEVICESETUP_FIRMWAREVERSION" | translate }}</span>
              </div>
            </th>
            <th>
              <div class="column-content">
                <img alt="Column" src="assets/device/column-menu.svg" />
                <span>{{ "DEVICESETUP_METERMODEL" | translate }}</span>
              </div>
            </th>
            <th>
              <div class="column-content">
                <img alt="Column" src="assets/device/column-menu.svg" />
                <span>{{ "DEVICESETUP_METERMAKE" | translate }}</span>
              </div>
            </th>
            <th>
              <div class="column-content">
                <img alt="Column" src="assets/device/column-menu.svg" />
                <span>{{ "FIRSTCONTACTDATE" | translate }}</span>
              </div>
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of data" (click)="handleRowClick(row)">
            <td></td>
            <td>
              <span (click)="clipboardService.copyToClipboard(row.meterNumber!, $event)" class="copyable">
                {{ row.meterNumber }}
                <span class="copy-tooltip" *ngIf="clipboardService.copiedText === row.meterNumber">{{"COPIED" |
                  translate}}</span>
              </span>
            </td>
            <td>
              <span>{{ row.meterIp }}</span>
            </td>
            <td>
              <span>{{ row.meterPort }}</span>
            </td>
            <td>
              <span>{{ row.meterFirmware }}</span>
            </td>
            <td>
              <span>{{ row.meterModelName }}</span>
            </td>
            <td>
              <span>{{ row.meterMakeName }}</span>
            </td>
            <td>
              <span>{{ row.firstContactDate | date: "dd MMM yyyy" }}</span>
            </td>
            <td>
              @if (
              authService.isAuthorized([
              PermissionsEnum.Settings_crud_area_delete,
              ])
              ) {
              <img class="p-0" alt="Delete" src="assets/core/table/delete.svg" (click)="handleDelete(row)" />
              }
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <app-confirm-dialog *ngIf="isModalOpen" titleKey="DELETE" question="DEVICES_DELETE"
    (confirm)="confirmDelete(selectedRow!)" (cancel)="cancelDelete()"></app-confirm-dialog>
  <div class="container-down">
    <app-pagination [lastPageSize]="lastPageSize" [numberOfDevices]="numberOfDevices" [pageSize]="pageSize"
      [currentPage]="currentPage" (pageChange)="pageChange($event)"></app-pagination>
  </div>
</div>